import React from 'react';
import { Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

function ConfirmationModalForUpload({ onOpen, toggle, title, description, handleNoButtonClick, handleYesButtonClick }) {
  const { t } = useTranslation('common');

  return (
    <Modal
      className="common-custom-modal modal-medium"
      aria-labelledby="contained-modal-title-vcenter"
      size="lg"
      show={onOpen}
      onHide={toggle}
      backdrop="static"
    >
      <Modal.Header>
        <Modal.Title>{title}</Modal.Title>
        <span onClick={() => handleNoButtonClick()} className="icon-close" />
      </Modal.Header>
      <Modal.Body>
        <div className="modal-inner-data">
          <div className="">
            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
            <span className="f-16 font-medium text-center">{description}</span>
          </div>
        </div>
        <div className="common-model-footer">
          <button aria-label="Save" title={t('BOM_LIBRARY.CONFIRMATION_MODAL.YES')} className="btn p-0" type="button" onClick={() => handleYesButtonClick()}>
            <i className="icon-Tick-1 f-24" />
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default ConfirmationModalForUpload;
